import React, { Component } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider, RequireAuth } from 'fennec-ui'
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import { ConfigProvider } from 'antd'
import { useMediaQuery } from 'react-responsive'
import { DeviceUUID } from "device-uuid"
import { IsDesktopOrLaptopContext, IsMobileContext } from './components/Context'

import Signup from './desktop/pages/Signup';
import Login from './desktop/pages/Login';
import Logout from './desktop/pages/Logout';
import LogoutAll from './desktop/pages/LogoutAll';
import ForgotPassword from './desktop/pages/ForgotPassword';
import ResetPassword from './desktop/pages/ResetPassword';
import EmailVerification from './desktop/pages/EmailVerification';
import Home from './desktop/pages/Home';

import HomeMobile from './mobile/pages/HomeMobile';

import TgDesktop from './desktop/pages/Tg';
import TgMobile from './mobile/pages/Tg';
import VkDesktop from './desktop/pages/Vk';
import VkMobile from './mobile/pages/Vk';

const store = configureStore();


// https://kamranicus.com/posts/2018-07-26-react-router-custom-transition-ui
const getUserConfirmation = (message, callback) => {
	console.log(message);
	callback(false);
}
function Layout(props) {
	let isMobile = false;
	try {
		isMobile = new DeviceUUID().parse()?.isMobile
	} catch (error) {
		console.error(error)
	}

	const isDesktopOrLaptop = useMediaQuery({ minWidth: 1224 })

	if (isDesktopOrLaptop || !isMobile) {
		return (
			<IsMobileContext.Provider value={isMobile}>
				<IsDesktopOrLaptopContext.Provider value={isDesktopOrLaptop}>
					<Routes>
						<Route path="/vk-link" element={<RequireAuth><VkDesktop /></RequireAuth>} />
						<Route path="/tg-link" element={<RequireAuth><TgDesktop /></RequireAuth>} />
						<Route path="/signup" element={<Signup />} exact />
						<Route path="/login" element={<Login />} exact />
						<Route path="/logout" element={<Logout />} exact />
						<Route path="/logoutall" element={<RequireAuth><LogoutAll /></RequireAuth>} exact />
						<Route path="/forgot-password" element={<ForgotPassword />} exact />
						<Route path="/reset-password" element={<ResetPassword />} exact />
						<Route path="/email-verification" element={<EmailVerification />} exact />

						<Route path="/*" element={<RequireAuth><Home /></RequireAuth>} />
					</Routes>
				</IsDesktopOrLaptopContext.Provider>
			</IsMobileContext.Provider >

		)
	} else {
		return (
			<Routes>
				<Route path="/vk-link" element={<RequireAuth><VkMobile /></RequireAuth>} />
				<Route path="/tg-link" element={<RequireAuth><TgMobile /></RequireAuth>} />
				<Route path="/signup" element={<Signup />} exact />
				<Route path="/login" element={<Login />} exact />
				<Route path="/logout" element={<Logout />} exact />
				<Route path="/logoutall" element={<RequireAuth><LogoutAll /></RequireAuth>} exact />
				<Route path="/forgot-password" element={<ForgotPassword />} exact />
				<Route path="/reset-password" element={<ResetPassword />} exact />
				<Route path="/email-verification" element={<EmailVerification />} exact />

				<Route path="/*" element={<RequireAuth><HomeMobile /></RequireAuth>} />
			</Routes>
		)
	}
}
function App(props) {
	React.useEffect(() => {
		window.addEventListener('popstate', function (e) {
			if (e.state && e.state.cb && window.historyCallbackFunctions && window.historyCallbackFunctions[e.state.cb]) {
				window.historyCallbackFunctions[e.state.cb].apply(this, arguments);
			}
		}, false);
	}, []);

	return (
		<div>
			<AuthProvider>
				<Provider store={store}>
					<BrowserRouter getUserConfirmation={getUserConfirmation}>
						<ConfigProvider>
							<Layout />
						</ConfigProvider>
					</BrowserRouter>
				</Provider>
			</AuthProvider>
		</div>
	)
}

export default App;